import dispatcher from '@/api/dispatcher';
import { differenceWith, filter, map, isEqual } from 'lodash';

const state = {
    calls: [],
    cars: [],
    nearestCars: [],
    soundPlayConfirmation: false,
    notifications: [],
    isCallNotificationSoundActive: false,
};

const getters = {
    callsList: (state) => state.calls,
    carsList: (state) => state.cars,
    notifications: (state) => state.notifications,
    soundPlayConfirmation: (state) => !state.soundPlayConfirmation,
    isCallNotificationSoundActive: (state) =>
        state.isCallNotificationSoundActive,
};

const actions = {
    // Принять вызов
    assignСall: ({ state, commit, dispatch }, payload) => {
        dispatcher
            .assignСall(payload)
            .then(() => {
                commit(
                    'callsUpdate',
                    state.calls.filter((call) => call.id !== payload.id)
                );
                commit('disableCallNotificationSound');
            })
            .catch((err) => {
                console.log(err);
            });
    },
    // Получить список автомобилей
    getCars: ({ commit }) => {
        dispatcher
            .fetchAllCars()
            .then((res) => {
                commit('carsUpdate', res.body.results);
            })
            .catch((error) => {
                console.log(error);
            });
    },
    // Получить список вызовов
    getCallsList: ({ state, commit, dispatch }) => {
        const calls = map(filter(state.calls, {status: 1}), 'id');
        dispatcher
            .getAllClimes()
            .then((response) => {
                const responseActiveCalls = map(filter(response.body.results, {status: 1}), 'id');
                const newCalls = differenceWith(responseActiveCalls, calls, isEqual);

                if (newCalls.length > 0) {
                    dispatch(
                        'notifications/ADD_NOTIFICATION',
                        {
                            type: 'warning',
                            text: 'Новый вызов',
                        },
                        { root: true }
                    );
                    commit('activateCallNotificationSound');
                }

                commit('callsUpdate', response.body.results);
            })
            .catch((err) => {
                console.log(err);
            });
    },
    assignPlaySound: ({ commit }) => {
        commit('assignPlaySoundUpdate');
    },
};

const mutations = {
    callsUpdate: (state, payload) => {
        state.calls = payload;
    },
    carsUpdate: (state, payload) => {
        state.cars = payload;
    },
    assignPlaySoundUpdate: (state) => {
        state.soundPlayConfirmation = true;
    },
    activateCallNotificationSound: (state) =>
        (state.isCallNotificationSoundActive = true),
    disableCallNotificationSound: (state) =>
        (state.isCallNotificationSoundActive = false),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
